let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9k700")).then(() => parcelRequire('9Ekqu'));